module.exports = __webpack_public_path__ + "img/lightbulb.e9400dad.gif";